/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
    ReimbursementTypeToJSONTyped,
} from './ReimbursementType';

/**
 * 
 * @export
 * @interface PayerContractUpdate
 */
export interface PayerContractUpdate {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    facility_ids?: Array<string>;
    /**
     * 
     */
    type?: PayerContractUpdateTypeEnum;
    /**
     * 
     */
    reimbursement_type?: ReimbursementType;
    /**
     * 
     */
    s3_key?: string;
    /**
     * 
     */
    expiry_date?: string | null;
    /**
     * 
     */
    processing_status?: PayerContractUpdateProcessingStatusEnum;
    /**
     * 
     */
    processing_error?: PayerContractUpdateProcessingErrorEnum;
}


/**
 * @export
 */
export const PayerContractUpdateTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type PayerContractUpdateTypeEnum = typeof PayerContractUpdateTypeEnum[keyof typeof PayerContractUpdateTypeEnum];

/**
 * @export
 */
export const PayerContractUpdateProcessingStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed',
    Error: 'error',
} as const;
export type PayerContractUpdateProcessingStatusEnum = typeof PayerContractUpdateProcessingStatusEnum[keyof typeof PayerContractUpdateProcessingStatusEnum];

/**
 * @export
 */
export const PayerContractUpdateProcessingErrorEnum = {
    Error: 'error',
    InsufficientInfo: 'insufficient_info',
    WrongPayer: 'wrong_payer',
} as const;
export type PayerContractUpdateProcessingErrorEnum = typeof PayerContractUpdateProcessingErrorEnum[keyof typeof PayerContractUpdateProcessingErrorEnum];


/**
 * Check if a given object implements the PayerContractUpdate interface.
 */
export function instanceOfPayerContractUpdate(value: object): value is PayerContractUpdate {
    return true;
}

export function PayerContractUpdateFromJSON(json: any): PayerContractUpdate {
    return PayerContractUpdateFromJSONTyped(json, false);
}

export function PayerContractUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerContractUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'facility_ids': json['facility_ids'] == null ? undefined : json['facility_ids'],
        'type': json['type'] == null ? undefined : json['type'],
        'reimbursement_type': json['reimbursement_type'] == null ? undefined : ReimbursementTypeFromJSON(json['reimbursement_type']),
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'expiry_date': json['expiry_date'] === undefined ? undefined : json['expiry_date'] === null ? null : json['expiry_date'],
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'processing_error': json['processing_error'] == null ? undefined : json['processing_error'],
    };
}

export function PayerContractUpdateToJSON(json: any): PayerContractUpdate {
    return PayerContractUpdateToJSONTyped(json, false);
}

export function PayerContractUpdateToJSONTyped(value?: PayerContractUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'facility_ids': value['facility_ids'],
        'type': value['type'],
        'reimbursement_type': ReimbursementTypeToJSON(value['reimbursement_type']),
        's3_key': value['s3_key'],
        'expiry_date': value['expiry_date'],
        'processing_status': value['processing_status'],
        'processing_error': value['processing_error'],
    };
}

